var map = {
	"./armement-le-secteur-redecouvert-sur-fond-de-guerre-en-europe@2x.webp": 3574,
	"./cryptomonaie-l-annee-horribilis@2x.webp": 2572,
	"./energie-plus-rien-ne-sera-comme-avant@2x.webp": 6901,
	"./esg-des-criteres-toujours-plus-verts-en-bourse@2x.webp": 2658,
	"./la-tech-us-en-bourse-fait-sa-purge@2x.webp": 3966,
	"./le-dollar-superstar@2x.webp": 3079,
	"./le-luxe-ne-craint-toujours-pas-la-crise@2x.webp": 6494,
	"./les-banques-centrales-face-la-deferlante-de-linflation@2x.webp": 8573,
	"./meta-le-debut-de-la-fin@2x.webp": 1410,
	"./twitter-lannee-ou-tout-bascule@2x.webp": 8411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3678;